import { render, staticRenderFns } from "./ReportChallengeDataPersonComponent.vue?vue&type=template&id=0826baf0&"
import script from "./ReportChallengeDataPersonComponent.vue?vue&type=script&lang=js&"
export * from "./ReportChallengeDataPersonComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports